import React from "react";
import { NavLink } from "react-router-dom";

import "./style.css";
let randomColors = [
  "#FF0000",
  "#DC5761",
  "#22A7E2",
  "#793C69",
  "#FF77A1",
  "#FF77A1",
  "#3BC872",
  "#723061",
  "#FF65AE",
  "#FA0000",
  "#DE5F69",
  "#FA0000",
  "#FA0000",
  "#723061",
  "#FA0000",
  "#FF65AE",
  "#FA0000",
  "#FF0081",
];

const ChannelCard = (props) => {
  return (
    <NavLink to={props.Channels_link}>
      <div className="channel-block channel-red">
        {props.Channels_img && (
          <div className="channel-logo">
            <img src={props.Channels_img} alt="img" />
          </div>
        )}
        <h4
          style={{
            color:
              randomColors[Math.floor(Math.random() * randomColors.length)],
          }}
        >{`${props.Channels_title} ${props.Channel_or_Team}`}</h4>
        <p id="body_text">{props.Channels_body}</p>
        <p id="border-style"></p>
        <p className="viewChannel">
          View {props.Channel_or_Team}
          <i className="fa fa-long-arrow-right"></i>
        </p>
      </div>
    </NavLink>
  );
};

export default ChannelCard;
